<div #map id='map' [class]='classToApply'></div>
